import { api } from "./client";
import type { DashboardFlightRow } from "@/types/api";

export interface DirectorySummary {
  pilots: number;
  instructors: number;
  active_pilots: number;
  flights: number;
}

export interface DirectoryUser {
  id: number;
  username: string;
  account_type: string;
  created_at: string;
  flight_count: number;
  last_flight_at: string | null;
}

export interface DirectoryOut {
  users: DirectoryUser[];
  summary: DirectorySummary;
}

export interface UserOverview {
  flight_count: number | null;
  mission_count: number | null;
  total_duration_seconds: number | null;
  avg_duration_seconds: number | null;
  avg_distance_m: number | null;
  avg_speed_mps: number | null;
  avg_smoothness_score: number | null;
  max_altitude_m: number | null;
  last_flight_at: string | null;
}

export interface UserDetailOut {
  id: number;
  username: string;
  account_type: string;
  created_at: string;
  overview: UserOverview;
  flights: DashboardFlightRow[];
}

export interface UsersCompareCandidate {
  id: number;
  username: string;
  color: string;
  flight_count: number;
  mission_count: number;
  avg_smoothness_score: number | null;
  avg_speed_kmh: number | null;
  series: number[];
  current_score: number;
  focus_title: string;
  focus_copy: string;
  mock_profile: string;
}

export interface UsersComparePayload {
  labels: string[];
  baseline: { label: string; series: number[] };
  candidates: UsersCompareCandidate[];
  default_selected_ids: number[];
  max_selection: number;
  palette: string[];
}

export interface UsersCompareOut {
  payload: UsersComparePayload;
  summary: { pilots: number; active_pilots: number; flights: number };
}

export function getUsers() {
  return api.get<DirectoryOut>("/api/users");
}

export function getUserDetail(userId: number) {
  return api.get<UserDetailOut>(`/api/users/${userId}`);
}

export function getUsersCompare() {
  return api.get<UsersCompareOut>("/api/users/compare");
}
